// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndiaCustomerName(customerNameValue: string): ?UserInputValidationError {
  if (!customerNameValue || customerNameValue.trim() === '') {
    return { id: 'empty' };
  }
  
  if (customerNameValue.length < 5) {
    return { id: 'min-length' };
  }
  
  const hasNumbersOrSpecialChars = /[^a-zA-Z\s]/.test(customerNameValue);
  if (hasNumbersOrSpecialChars) {
    return { id: 'invalid-characters' };
  }
  
  return undefined;
}
